import { Node, mergeAttributes } from "@tiptap/react";

/**
 * Atomic-inline узел `{{плейсхолдера}}`. Атрибут `path` хранит имя переменной.
 * И в editor view, и при сериализации даёт `<span data-placeholder="path">{{path}}</span>` —
 * `htmlToTemplate` после `getHTML()` снимает обёртку до литерального `{{path}}`,
 * который ждёт backend.
 */
export const PlaceholderNode = Node.create({
  name: "placeholder",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      path: {
        default: "",
        parseHTML: (el: HTMLElement) =>
          el.getAttribute("data-placeholder") ?? "",
        // Атрибут пишем в DOM вручную через `renderHTML` (data-placeholder),
        // дефолтный addAttributes-рендер дал бы лишний `path="..."` на span.
        rendered: false,
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-placeholder]" }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const path = String(node.attrs.path ?? "");
    return [
      "span",
      mergeAttributes(HTMLAttributes, { "data-placeholder": path }),
      `{{${path}}}`,
    ];
  },

  renderText({ node }) {
    return `{{${node.attrs.path}}}`;
  },
});
